// ============================================================
// GUIDE UI STRINGS — FR / EN
// ------------------------------------------------------------
// Interface labels for the Guide (menu, buttons, section titles).
// Chapter content lives in /content/guide.js (FR) and
// /content/guide.en.js (EN).
// ============================================================

export const GUIDE_UI = {
  // ==== Sommaire (index) ====
  eyebrow:       { fr: "Guide du Voyageur",              en: "Traveler's Guide" },
  title:         { fr: ["Votre ", "carnet", " de séjour"], en: ["Your stay ", "companion", ""] },
  subtitle:      {
    fr: "Feuilletez selon le besoin du moment — avant, pendant et après votre séjour.",
    en: "Browse whenever you need — before, during and after your stay.",
  },
  back:          { fr: "Retour",                          en: "Back" },
  backToGuide:   { fr: "Retour au Guide",                 en: "Back to Guide" },
  backToSummary: { fr: "Revenir au sommaire",             en: "Back to contents" },

  // ==== Sections (côté sommaire) ====
  sectionAvant:      { fr: "I · Avant l'arrivée",       en: "I · Before arrival" },
  sectionPendant:    { fr: "II · Pendant le séjour",    en: "II · During your stay" },
  sectionBesoin:     { fr: "III · En cas de besoin",    en: "III · If you need us" },
  sectionDepart:     { fr: "IV · Le départ",            en: "IV · Departure" },
  sectionGoFurther:  { fr: "Aller plus loin",           en: "Go further" },

  // ==== Items (labels du menu) ====
  itemAdresse:       { fr: "L'adresse",                  en: "The address" },
  itemCodeAcces:     { fr: "Le code d'accès",            en: "The access code" },
  itemTransport:     { fr: "Transport",                  en: "Transport" },
  itemWifi:          { fr: "Wifi",                       en: "Wifi" },
  itemBassin:        { fr: "Le bassin",                  en: "The pool" },
  itemBassinSub:     { fr: "Le bain minéral",            en: "The mineral bath" },
  itemEclairage:     { fr: "Éclairage & son",            en: "Lighting & sound" },
  itemEclairageSub:  { fr: "Lumière, musique, cinéma",   en: "Light, music, cinema" },
  itemEquipements:   { fr: "Équipements",                en: "Equipment" },
  itemCuisine:       { fr: "La cuisine",                 en: "The kitchen" },
  itemClimatisation: { fr: "Climatisation",              en: "Air conditioning" },
  itemRegles:        { fr: "Règles de la maison",        en: "House rules" },
  itemUrgences:      { fr: "Urgences",                   en: "Emergencies" },
  itemUrgencesSub:   { fr: "Numéros et gestes clés",     en: "Numbers and key actions" },
  itemContact:       { fr: "Contact & réseaux",          en: "Contact & socials" },
  itemDepart:        { fr: "Refermer la porte",          en: "Closing the door" },

  // ==== Passerelle Expériences ====
  bridgeExpLabel:    { fr: "Les expériences",            en: "The experiences" },
  bridgeExpSub:      { fr: "Bain de fleurs · Petit-déjeuner · Décors", en: "Flower bath · Breakfast · Décor" },

  // ==== Footer ====
  footerQuestion:    { fr: "Une question ? Un besoin ?", en: "A question? Any need?" },
  footerWhatsApp:    { fr: "Écrire sur WhatsApp",        en: "Write on WhatsApp" },
  footerQRLink:      { fr: "Carte QR à imprimer",        en: "Printable QR card" },

  // ==== Page titles (document.title) ====
  docTitleIndex:     { fr: "Le Guide du Voyageur — Curieux Refuge", en: "The Traveler's Guide — Curieux Refuge" },
  docTitleUnknown:   { fr: "Guide · Curieux Refuge",     en: "Guide · Curieux Refuge" },
  chapterUnknown1:   { fr: "Ce chapitre se prépare.",    en: "This chapter is coming soon." },
  chapterUnknown2:   { fr: "Il sera bientôt disponible.", en: "It will be available shortly." },
};

/** Helper: translate a UI key with a language, safe fallback to FR. */
export function tr(key, lang = "fr") {
  const entry = GUIDE_UI[key];
  if (!entry) return "";
  return entry[lang] ?? entry.fr ?? "";
}
